import { put } from "redux-saga/effects";
import * as ActionTypes from './ActionType';

export function* GetOnboardingEnableSaga(payload) {
    yield put({ type: ActionTypes.ONBOARDING_ENABLE_ADD_RESPONSE, payload: payload.params })
}
